import React, { Dispatch, SetStateAction, useCallback } from "react";
import { useDispatch } from "react-redux";
import { officeApi } from "../../api/config";
import { LoadingChange, ToastChange } from "../../reducers/config";
import "./css/index.css";
function Login({
  setIsLogin,
}: {
  setIsLogin: Dispatch<SetStateAction<boolean>>;
}) {
  const dispatch = useDispatch();
  const __login = useCallback(
    (e: any) => {
      dispatch(LoadingChange(true));
      const { target } = e;
      const id = target[0].value;
      const password = target[1].value;
      officeApi
        .post("/auth/signin", {
          login_id: id,
          login_pwd: password,
        })
        .then(({ data }) => {
          if (data.sts_fg) {
            const { accessToken, usr_nm } = data.succ_obj;
            if (usr_nm === "관리자") {
              window.sessionStorage.setItem("accessToken", accessToken);
              setIsLogin(true);
            } else {
              dispatch(
                ToastChange({
                  active: true,
                  content: "관리자 계정으로 로그인해주세요",
                })
              );
            }
          } else {
            dispatch(
              ToastChange({
                active: true,
                content: data.err_msg,
              })
            );
          }
          dispatch(LoadingChange(false));
        })
        .catch((err) => {
          dispatch(LoadingChange(false));
        });
    },
    [setIsLogin, dispatch]
  );

  return (
    <main className="login-section">
      <form
        className="login-wrapper"
        onSubmit={(e) => {
          e.preventDefault();
          __login(e);
        }}
      >
        <img src="/assets/logo.svg" alt="" />
        <div className="title">마이팀플 관리자 웹</div>
        <div className="input-section">
          <div className="input-wrapper">
            <div className="title">아이디</div>
            <input type="text" placeholder="아이디 입력" id="id" />
          </div>
          <div className="input-wrapper">
            <div className="title">패스워드</div>
            <input type="password" placeholder="비밀번호 입력" id="password" />
          </div>
        </div>
        <button id="submit">로그인</button>
      </form>
    </main>
  );
}

export default Login;
